import { ElementRef, Injectable, Renderer2, Type } from '@angular/core';

@Injectable()
export class CxUiComponentService<P = Type<unknown>> {
  constructor(private rdr2: Renderer2, private host: ElementRef) {}

  public setProperty(property: keyof P & string, value: unknown) {
    this.rdr2.setProperty(this.host.nativeElement, property, value);
  }

  public hasSomeAttributeOf(attributes: unknown[]) {
    if (attributes.some(attribute => !!attribute)) {
      console.warn(
        '☸ For better performance, dynamic updates, type safety, and code consistency, please prefer using property binding.',
      );
    }
  }
}
